define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.push;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/push.js
// module id = 351
// module chunks = 1